import "./facebook-login";
import "./google-login";
import "./account";
import "./modules/popup-manager";
import "./modules/form-manager";
import "./modules/ajax-manager";
import Header from "./modules/header";
import Menu from "./modules/menu";

import "./modules/player";
import "./modules/comments";
import "./modules/sliders";
import "./modules/listing";

import AOS from "aos";
import 'aos/dist/aos.css';

import "../scss/theme.scss";

Header().init();
Menu().init();
AOS.init();